import { useCallback, useMemo } from 'react'

import { useOfferReasonPopup } from '@wwt/core/reason'
import { Offer } from '@wwt/entities/search-response'
import { useSessionLikesStore } from '@wwt/store/sessionLikes/sessionLikesStore.ts'

import {
	getDisliked,
	useDislikeMutation,
	useDislikes,
	useLikeIds,
	useLikeMutation,
	useUndislikeMutation,
	useUnlikeMutation
} from '@/entities/likeDislike'

export const useOfferReaction = (
	offer: Offer | null,
	// TODO: Yes, it's bad. Any ideas on how to improve it?
	onDislikeCancel?: () => void
) => {
	const likeIds = useLikeIds()
	const dislikes = useDislikes()

	const like = useLikeMutation()
	const unlike = useUnlikeMutation()

	const dislike = useDislikeMutation()
	const undislike = useUndislikeMutation()

	const { showLikePopup, showDislikePopup } =
		useOfferReasonPopup(onDislikeCancel)

	const incrementSessionLikes = useSessionLikesStore.use.increment()
	const decrementSessionLikes = useSessionLikesStore.use.decrement()

	const isLiked = Boolean(
		likeIds.data && offer && likeIds.data[offer.IDs.nonPersistingOfferId]
	)
	const isDisliked = Boolean(
		dislikes.data && offer && getDisliked(dislikes.data, offer)
	)

	// XXX: Fix me
	const handleDislike = useCallback(
		() => {
			if (!offer) {
				throw new Error('Current offer is null')
			}

			if (isDisliked) {
				undislike.mutate(offer)
				return
			}

			dislike.mutate(offer)
			showDislikePopup(offer)
		},
		// eslint-disable-next-line
		[
			isDisliked,
			isLiked,
			offer,
			decrementSessionLikes,
			showDislikePopup
			// TODO: IDK why but it cause infinity render's
			// undislike,
			// unlike,
			// dislike
		]
	)

	// XXX: Fix me
	const handleLike = useCallback(
		() => {
			if (!offer) {
				throw new Error('Current offer is null')
			}

			if (isLiked) {
				unlike.mutate(offer)
				decrementSessionLikes()
				return
			}

			like.mutate(offer)
			incrementSessionLikes()
			showLikePopup(offer)
		},
		// eslint-disable-next-line
		[
			isDisliked,
			isLiked,
			offer,
			incrementSessionLikes,
			showLikePopup
			// TODO: IDK why but it cause infinity render's
			// undislike,
			// unlike,
			// like
		]
	)

	// XXX: Fix me
	return useMemo(
		() => ({
			isLiked,
			isDisliked,
			handleLike,
			handleDislike
			// DEV: Add isLoading
		}),
		[isLiked, isDisliked, handleLike, handleDislike]
	)
}
